"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var es = {
  ItemCountOfTotalCount: 'Elemento {{index}} de {{pagerCount}}',
  'Currently Active': 'Elemento activo'
};
var _default = es;
exports["default"] = _default;
//# sourceMappingURL=es.js.map